/* import __COLOCATED_TEMPLATE__ from './free-input-editor.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();